export const RentalCarServiceCode = 'LE';
